// store.js
import { configureStore } from '@reduxjs/toolkit';
import ordersReducer from './ordersSlice';
import {
	persistStore,
	persistReducer,
	FLUSH,
	REHYDRATE,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage
import { combineReducers } from 'redux';
import addProductsReducer from '../Components/AddProducts/AddProductsSlice';
import { catalogApi } from './catalogApi';


const rootReducer = combineReducers({
	orders: ordersReducer,
	addProducts: addProductsReducer,
	[catalogApi.reducerPath]: catalogApi.reducer,
});

const persistConfig = {
	key: 'root',
	storage,
	whitelist: ['orders'], // Only persist the 'orders' slice
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				// Ignore action types from redux-persist
				ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
			},
		}).concat(catalogApi.middleware),
});

export const persistor = persistStore(store);
